import { Capacitor } from '@capacitor/core'
import { ColoursObj, MainButton, Typography } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useSignal } from '@preact/signals-react'
import { useEffect } from 'react'
import { useShallow } from 'zustand/react/shallow'
import Image from '../../assets/illustrations/LandingImage.webp'
import { LogoWithText } from '../../assets/svgImages/logoWithText'
import i18n from '../../i18n/i18next'
import { bs } from '../../state/bound.store'
import { backgroundImageUrl } from '../../state/windowState/windowSignals'
import { isWebPreview } from '../../utils'
import { reactAppStage } from '../../utils/reactAppStage'
import { switchStage } from '../appState/appStateListener'
import { useDeviceInfo } from '../appState/deviceInfo'
import {
    setStatusBarStyleDark,
    setStatusBarStyleLight,
} from '../appState/statusBar'
import { ds } from '../developerMenu/devSettings.slice'

export const WelcomePage = () => {
    const { version } = useDeviceInfo(
        useShallow((s) => {
            return { version: s.version }
        })
    )
    const taps = useSignal(0)

    useEffect(() => {
        backgroundImageUrl.value = Image

        if (Capacitor.isNativePlatform()) {
            setStatusBarStyleDark()
        }

        return () => {
            backgroundImageUrl.value = ''

            if (!Capacitor.isNativePlatform()) return
            if (ColoursObj.navbar.light) {
                setStatusBarStyleDark()
            } else {
                setStatusBarStyleLight()
            }
        }
    }, [])

    const onLogoClick = () => {
        taps.value = taps.peek() + 1
        if (taps.value === 10) {
            taps.value = 0
            if (reactAppStage() === 'demo') {
                switchStage('test')
                return
            }
            if (reactAppStage() === 'test') {
                switchStage('dev')
                return
            }
            if (reactAppStage() === 'dev') {
                switchStage('demo')
                return
            }
            switchStage('demo')
        }
    }

    return (
        <Stack height={'100%'} justifyContent={'space-between'}>
            <Stack
                onClick={onLogoClick}
                paddingTop={'21px'}
                alignItems={'center'}
                height={'128px'}
            >
                <LogoWithText />
            </Stack>
            {!isWebPreview && (
                <Stack
                    spacing={'16px'}
                    padding={'16px'}
                    width={'calc(100% - 32px)'}
                >
                    <MainButton
                        id="signinButton"
                        onClick={() => {
                            window.pushPath('authentication/signin')
                        }}
                    >
                        {i18n.t('authentication.sign-in.sign-in')}
                    </MainButton>
                    {ds().isImpersonateOn && (
                        <MainButton
                            id="devSignInButton"
                            onClick={() => {
                                bs().signInRedirect()
                            }}
                        >
                            Dev Sign In
                        </MainButton>
                    )}

                    <MainButton
                        id="createAccountButton"
                        onClick={() => {
                            window.pushPath('authentication/signUp')
                        }}
                        variant="secondary"
                    >
                        <Typography color={ColoursObj.core.secondary}>
                            {i18n.t('authentication.sign-up.create-account')}
                        </Typography>
                    </MainButton>
                    <Stack direction={'row'} justifyContent={'center'}>
                        <Typography
                            id={'appVersion' + version.buildVersion}
                            color={'white'}
                            variant="bodySubtext"
                        >
                            {version.buildVersion}
                        </Typography>
                    </Stack>
                </Stack>
            )}
        </Stack>
    )
}
